<nav>
    <div class="cvx-navbar-wrapper">
        <div class="icon-container" 
            [class.disabled]="dropdownsLoading || !canOpenSettings()"
            [attr.aria-disabled]="dropdownsLoading || !canOpenSettings()"
            (click)="openSettingsModal()">
            <fa-icon *ngIf="!dropdownsLoading; else spinnerTpl" [icon]="faGear"></fa-icon>
            <ng-template #spinnerTpl>
             <fa-icon [icon]="faSpinner" class="spinner-icon fa-spin-pulse"></fa-icon>
            </ng-template>
        </div> 
    </div>

    <app-modal-settings
    [isVisible]="isModalOpen" 
    (close)="closeModal()"></app-modal-settings>
</nav>
